export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var AbstractLogger = /** @class */ (function () {
    function AbstractLogger(name) {
        this.defaultLevel = LogLevel.WARN;
        // tslint:disable-next-line:no-empty
        this.noop = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
        };
        // tslint:disable-next-line:strict-boolean-expressions
        this.name = name || '';
        this.setDefaultLevelFromLocalStorage();
    }
    AbstractLogger.prototype.setLevel = function (level) {
        this.level = level;
    };
    AbstractLogger.prototype.getLevel = function () {
        return typeof this.level === 'number' && isFinite(this.level) && Math.floor(this.level) === this.level ? this.level : this.defaultLevel;
    };
    AbstractLogger.prototype.shouldLog = function (method) {
        // level not sufficient
        switch (this.getLevel()) {
            case LogLevel.SILENT:
                return false;
            case LogLevel.ERROR:
                return method === 'error';
            case LogLevel.WARN:
                return method === 'error' || method === 'warn';
            case LogLevel.INFO:
                return method === 'error' || method === 'warn' || method === 'info';
            case LogLevel.DEBUG:
                return method === 'error' || method === 'warn' || method === 'info' || method === 'log';
            case LogLevel.TRACE:
            default:
                return true;
        }
    };
    AbstractLogger.prototype.setDefaultLevelFromLocalStorage = function () {
        if (!global.window || !global.window.hasOwnProperty('localStorage')) {
            return;
        }
        var loglevel = global.window.localStorage.getItem('loglevel');
        if (!loglevel) {
            return;
        }
        var level = loglevel.toLowerCase();
        switch (level) {
            case 'silent':
                this.defaultLevel = LogLevel.SILENT;
                break;
            case 'error':
                this.defaultLevel = LogLevel.ERROR;
                break;
            case 'warn':
                this.defaultLevel = LogLevel.WARN;
                break;
            case 'info':
                this.defaultLevel = LogLevel.INFO;
                break;
            case 'debug':
                this.defaultLevel = LogLevel.DEBUG;
                break;
            case 'trace':
                this.defaultLevel = LogLevel.TRACE;
                break;
            default: // invalid log level
        }
    };
    // tslint:disable-next-line:variable-name
    AbstractLogger.getLogger = function (name, LoggerClass) {
        if (AbstractLogger.loggers.hasOwnProperty(name)) {
            return AbstractLogger.loggers[name];
        }
        var logger = new LoggerClass(name);
        AbstractLogger.loggers[name] = logger;
        return logger;
    };
    AbstractLogger.loggers = {};
    return AbstractLogger;
}());
export { AbstractLogger };
//# sourceMappingURL=AbstractLogger.js.map